<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header v-if="!testMessageSend && !testMessageSendError"
        :header-title="'Test before send massive campaign'" :header-content="''" />

      <div v-if="!testMessageSend && !testMessageSendError">
        <form class="flex flex-col w-full items-start" @submit.prevent="sendTestMessage()">
          <div class="w-full">
            <p>
              Send Test Message to the following phone number
            </p>

            <label :class="{ error: $v.phoneNumber.$error }">
              {{ 'Phone number' }}
              <div class="flex items-center">
                <!-- Dropdown para seleccionar el código de país -->
                <select v-model="selectedCountryCode" class="mr-2" @change="$v.selectedCountryCode.$touch">
                  <option value="" disabled>Select Country Code</option>
                  <option v-for="country in countryCodes" :key="country.code" :value="country.code">
                    {{ country.country }} ({{ country.code }})
                  </option>
                </select>

                <!-- Input para ingresar el número de teléfono -->
                <input v-model.trim="phoneNumber" type="text" :placeholder="'Add a phone number here'"
                  @input="$v.phoneNumber.$touch" />
              </div>
              <span v-if="$v.selectedCountryCode.$error" class="message">
                {{ 'Please select a valid country code.' }}
              </span>
              <span v-if="$v.phoneNumber.$error" class="message">
                {{ 'Please enter a valid phone number starting with the selected country code.' }}
              </span>
            </label>

          </div>


          <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
            <div class="w-full">
              <woot-submit-button :disabled="$v.phoneNumber.$invalid ||
                uiFlags.isCreating
                " :button-text="'Send Test Message'" :loading="uiFlags.isSendingTest" />
              <button class="button clear" @click.prevent="onClose">
                {{ $t('AGENT_MGMT.ADD.CANCEL_BUTTON_TEXT') }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div v-if="testMessageSend && !testMessageSendError" class="w-full p-8 p-8  text-center">
        <h1 class="mb-8">Test Message was succesfully sent</h1>
        <p class="mb-8 !text-red-600">Be aware that test message could take some time to appear in the test number</p>
        <button class="button" @click.prevent="onCloseModal">
          {{ $t('OK') }}
        </button>
      </div>

      <div v-if="testMessageSendError" class="w-full p-8 p-8  text-center">
        <h1 class="mb-8 !text-red-600">Ups! Something wrong happened. Please contact support for more information</h1>
        <button class="button" @click.prevent="onCloseModal">
          {{ $t('OK') }}
        </button>
      </div>



    </div>
  </woot-modal>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { VUE_APP_API_FLOWS_BASE_URL } from '../../../../../config/index'
export default {
  props: {
    onClose: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      phoneNumber: '',
      selectedCountryCode: '',
      show: true,
      testMessageSend: false,
      testMessageSendError: false,
      countryCodes: [
        { code: '+93', country: 'Afghanistan' },
        { code: '+355', country: 'Albania' },
        { code: '+213', country: 'Algeria' },
        { code: '+376', country: 'Andorra' },
        { code: '+244', country: 'Angola' },
        { code: '+1', country: 'Antigua and Barbuda' },
        { code: '+54', country: 'Argentina' },
        { code: '+374', country: 'Armenia' },
        { code: '+61', country: 'Australia' },
        { code: '+43', country: 'Austria' },
        { code: '+994', country: 'Azerbaijan' },
        { code: '+973', country: 'Bahrain' },
        { code: '+880', country: 'Bangladesh' },
        { code: '+1', country: 'Barbados' },
        { code: '+375', country: 'Belarus' },
        { code: '+32', country: 'Belgium' },
        { code: '+501', country: 'Belize' },
        { code: '+229', country: 'Benin' },
        { code: '+975', country: 'Bhutan' },
        { code: '+591', country: 'Bolivia' },
        { code: '+387', country: 'Bosnia and Herzegovina' },
        { code: '+267', country: 'Botswana' },
        { code: '+55', country: 'Brazil' },
        { code: '+673', country: 'Brunei' },
        { code: '+359', country: 'Bulgaria' },
        { code: '+226', country: 'Burkina Faso' },
        { code: '+257', country: 'Burundi' },
        { code: '+855', country: 'Cambodia' },
        { code: '+237', country: 'Cameroon' },
        { code: '+1', country: 'Canada' },
        { code: '+238', country: 'Cape Verde' },
        { code: '+236', country: 'Central African Republic' },
        { code: '+235', country: 'Chad' },
        { code: '+56', country: 'Chile' },
        { code: '+86', country: 'China' },
        { code: '+57', country: 'Colombia' },
        { code: '+269', country: 'Comoros' },
        { code: '+242', country: 'Congo' },
        { code: '+506', country: 'Costa Rica' },
        { code: '+385', country: 'Croatia' },
        { code: '+53', country: 'Cuba' },
        { code: '+357', country: 'Cyprus' },
        { code: '+420', country: 'Czech Republic' },
        { code: '+45', country: 'Denmark' },
        { code: '+253', country: 'Djibouti' },
        { code: '+1', country: 'Dominica' },
        { code: '+1', country: 'Dominican Republic' },
        { code: '+593', country: 'Ecuador' },
        { code: '+20', country: 'Egypt' },
        { code: '+503', country: 'El Salvador' },
        { code: '+240', country: 'Equatorial Guinea' },
        { code: '+291', country: 'Eritrea' },
        { code: '+372', country: 'Estonia' },
        { code: '+251', country: 'Ethiopia' },
        { code: '+679', country: 'Fiji' },
        { code: '+358', country: 'Finland' },
        { code: '+33', country: 'France' },
        { code: '+241', country: 'Gabon' },
        { code: '+220', country: 'Gambia' },
        { code: '+995', country: 'Georgia' },
        { code: '+49', country: 'Germany' },
        { code: '+233', country: 'Ghana' },
        { code: '+30', country: 'Greece' },
        { code: '+1', country: 'Grenada' },
        { code: '+502', country: 'Guatemala' },
        { code: '+224', country: 'Guinea' },
        { code: '+245', country: 'Guinea-Bissau' },
        { code: '+592', country: 'Guyana' },
        { code: '+509', country: 'Haiti' },
        { code: '+504', country: 'Honduras' },
        { code: '+852', country: 'Hong Kong' },
        { code: '+36', country: 'Hungary' },
        { code: '+354', country: 'Iceland' },
        { code: '+91', country: 'India' },
        { code: '+62', country: 'Indonesia' },
        { code: '+98', country: 'Iran' },
        { code: '+964', country: 'Iraq' },
        { code: '+353', country: 'Ireland' },
        { code: '+972', country: 'Israel' },
        { code: '+39', country: 'Italy' },
        { code: '+1', country: 'Jamaica' },
        { code: '+81', country: 'Japan' },
        { code: '+962', country: 'Jordan' },
        { code: '+7', country: 'Kazakhstan' },
        { code: '+254', country: 'Kenya' },
        { code: '+686', country: 'Kiribati' },
        { code: '+82', country: 'South Korea' },
        { code: '+383', country: 'Kosovo' },
        { code: '+965', country: 'Kuwait' },
        { code: '+996', country: 'Kyrgyzstan' },
        { code: '+856', country: 'Laos' },
        { code: '+371', country: 'Latvia' },
        { code: '+961', country: 'Lebanon' },
        { code: '+266', country: 'Lesotho' },
        { code: '+231', country: 'Liberia' },
        { code: '+218', country: 'Libya' },
        { code: '+423', country: 'Liechtenstein' },
        { code: '+370', country: 'Lithuania' },
        { code: '+352', country: 'Luxembourg' },
        { code: '+853', country: 'Macau' },
        { code: '+389', country: 'Macedonia' },
        { code: '+261', country: 'Madagascar' },
        { code: '+265', country: 'Malawi' },
        { code: '+60', country: 'Malaysia' },
        { code: '+960', country: 'Maldives' },
        { code: '+223', country: 'Mali' },
        { code: '+356', country: 'Malta' },
        { code: '+692', country: 'Marshall Islands' },
        { code: '+222', country: 'Mauritania' },
        { code: '+230', country: 'Mauritius' },
        { code: '+52', country: 'Mexico' },
        { code: '+691', country: 'Micronesia' },
        { code: '+373', country: 'Moldova' },
        { code: '+377', country: 'Monaco' },
        { code: '+976', country: 'Mongolia' },
        { code: '+382', country: 'Montenegro' },
        { code: '+212', country: 'Morocco' },
        { code: '+258', country: 'Mozambique' },
        { code: '+95', country: 'Myanmar' },
        { code: '+264', country: 'Namibia' },
        { code: '+674', country: 'Nauru' },
        { code: '+977', country: 'Nepal' },
        { code: '+31', country: 'Netherlands' },
        { code: '+64', country: 'New Zealand' },
        { code: '+505', country: 'Nicaragua' },
        { code: '+227', country: 'Niger' },
        { code: '+234', country: 'Nigeria' },
        { code: '+47', country: 'Norway' },
        { code: '+968', country: 'Oman' },
        { code: '+92', country: 'Pakistan' },
        { code: '+680', country: 'Palau' },
        { code: '+970', country: 'Palestine' },
        { code: '+507', country: 'Panama' },
        { code: '+675', country: 'Papua New Guinea' },
        { code: '+595', country: 'Paraguay' },
        { code: '+51', country: 'Peru' },
        { code: '+63', country: 'Philippines' },
        { code: '+48', country: 'Poland' },
        { code: '+351', country: 'Portugal' },
        { code: '+974', country: 'Qatar' },
        { code: '+40', country: 'Romania' },
        { code: '+7', country: 'Russia' },
        { code: '+250', country: 'Rwanda' },
        { code: '+966', country: 'Saudi Arabia' },
        { code: '+221', country: 'Senegal' },
        { code: '+381', country: 'Serbia' },
        { code: '+248', country: 'Seychelles' },
        { code: '+232', country: 'Sierra Leone' },
        { code: '+65', country: 'Singapore' },
        { code: '+421', country: 'Slovakia' },
        { code: '+386', country: 'Slovenia' },
        { code: '+677', country: 'Solomon Islands' },
        { code: '+252', country: 'Somalia' },
        { code: '+27', country: 'South Africa' },
        { code: '+211', country: 'South Sudan' },
        { code: '+34', country: 'Spain' },
        { code: '+94', country: 'Sri Lanka' },
        { code: '+249', country: 'Sudan' },
        { code: '+597', country: 'Suriname' },
        { code: '+268', country: 'Swaziland' },
        { code: '+46', country: 'Sweden' },
        { code: '+41', country: 'Switzerland' },
        { code: '+963', country: 'Syria' },
        { code: '+886', country: 'Taiwan' },
        { code: '+992', country: 'Tajikistan' },
        { code: '+255', country: 'Tanzania' },
        { code: '+66', country: 'Thailand' },
        { code: '+670', country: 'Timor-Leste' },
        { code: '+228', country: 'Togo' },
        { code: '+676', country: 'Tonga' },
        { code: '+1', country: 'Trinidad and Tobago' },
        { code: '+216', country: 'Tunisia' },
        { code: '+90', country: 'Turkey' },
        { code: '+993', country: 'Turkmenistan' },
        { code: '+688', country: 'Tuvalu' },
        { code: '+256', country: 'Uganda' },
        { code: '+380', country: 'Ukraine' },
        { code: '+971', country: 'United Arab Emirates' },
        { code: '+44', country: 'United Kingdom' },
        { code: '+1', country: 'United States' },
        { code: '+598', country: 'Uruguay' },
        { code: '+998', country: 'Uzbekistan' },
        { code: '+678', country: 'Vanuatu' },
        { code: '+379', country: 'Vatican City' },
        { code: '+58', country: 'Venezuela' },
        { code: '+84', country: 'Vietnam' },
        { code: '+967', country: 'Yemen' },
        { code: '+260', country: 'Zambia' },
        { code: '+263', country: 'Zimbabwe' }
      ]
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'campaignsManager/getUIFlags',
      currentUser: 'getCurrentUser',
      campaign: 'campaignsManager/getCampaign',
      excelTemplateSampleData: 'campaignsManager/getTemplateSampleData',
      segmentTemplateSampleData: 'campaignsManager/getSegmentTemplateSampleData',
    }),
    templateSampleData() {
      return this.campaign?.audienceSource === 'segment'
        ? this.segmentTemplateSampleData
        : this.excelTemplateSampleData;
    },
  },
  validations() {
    const validCountryCode = (value) => {
      // Verifica si el código de país seleccionado está en la lista de códigos
      return this.countryCodes.some(country => country.code === value);
    };

    const validPhoneNumber = (value) => {
      // Combina el código de país y el número de teléfono para validar el formato completo
      const fullPhoneNumber = this.selectedCountryCode + this.phoneNumber;
      return /^\+?\d{1,3}\d{9,10}$/.test(fullPhoneNumber);
    };

    return {
      selectedCountryCode: { required, validCountryCode },
      phoneNumber: { required, validPhoneNumber }
    };
  },

  methods: {
    showAlert(message) {
      this.$emit('newToastMessage', message);
    },
    onCloseModal() {
      this.testMessageSend = false;
      this.testMessageSendError = false;
      this.onClose();
    },
    async sendTestMessage() {

      this.testMessageSend = false;
      this.testMessageSendError = false;
      console.log(JSON.stringify(this.getPayLoad()));

      console.log(this.templateSampleData)
      //;

      try {

        await this.$store.dispatch('campaignsManager/sendTestMessage', this.getPayLoad());
        this.testMessageSend = true

      } catch (error) {
        this.testMessageSend = false;
        this.testMessageSendError = true;
        const {
          response: {
            data: {
              error: errorResponse = '',
              attributes: attributes = [],
              message: attrError = '',
            } = {},
          } = {},
        } = error;
      }
    },
    getPayLoad() {
      const sourceTypes = this.campaign.paramSourceTypes || {
        body: {},
        header: {},
        media: {},
        buttons: {},
      };

      const resolveField = (category, key, rawValue) => {
        const isStatic =
          (category === 'body' && sourceTypes.body[key] === 'static') ||
          (category === 'header' && sourceTypes.header[key] === 'static') ||
          (category === 'buttons' && sourceTypes.buttons[key] === 'static');
        return isStatic ? rawValue : this.templateSampleData[rawValue];
      };

      let params = this.campaign.templateVars.reduce((acc, obj) => {
        const keyObj = Object.keys(obj)[0];
        const newKey = isNaN(keyObj)
          ? keyObj
          : parseInt(keyObj, 10).toString();
        acc[`${newKey}`] = resolveField('body', keyObj, obj[keyObj]);
        return acc;
      }, {});

      let paramsHeader = this.campaign.templateHeaderVars.reduce((acc, obj) => {
        const keyObj = Object.keys(obj)[0];
        acc[keyObj] = resolveField('header', keyObj, obj[keyObj]);
        return acc;
      }, {});

      let paramsButtons = this.campaign.templateButtonsVars.reduce((acc, obj) => {
        const keyObj = Object.keys(obj)[0];
        acc[keyObj] = resolveField('buttons', keyObj, obj[keyObj]);
        return acc;
      }, {});

      if (this.campaign.templateMediaImage) {
        const link =
          sourceTypes.media.Image === 'file'
            ? this.campaign.templateMediaImage.field
            : this.templateSampleData[this.campaign.templateMediaImage.field];
        paramsHeader = {
          image: { type: 'image', image: { link } },
        };
      }

      if (this.campaign.templateMediaVideo) {
        const link =
          sourceTypes.media.Video === 'file'
            ? this.campaign.templateMediaVideo.field
            : this.templateSampleData[this.campaign.templateMediaVideo.field];
        paramsHeader = {
          video: { type: 'video', video: { link } },
        };
      }

      if (this.campaign.templateMediaDocument) {
        const link =
          sourceTypes.media.Document === 'file'
            ? this.campaign.templateMediaDocument.field
            : this.templateSampleData[this.campaign.templateMediaDocument.field];
        paramsHeader = {
          document: { type: 'document', document: { link } },
        };
      }


      let payload = {
        messages: [{
          template_configuration: {
            template_name: this.campaign.templateName,
            language_code : this.campaign.templateLanguage,
            template_params: {
              body_params:  params ,
              header_params: paramsHeader ? paramsHeader : {},
              button_params:paramsButtons? paramsButtons:{},
              footer_params:[]
            }
          },
          account_id: parseInt(this.$route.params.accountId),
          inbox_id: parseInt(this.campaign.inboxID),
          phone_number: `${this.selectedCountryCode}${this.phoneNumber}`

        }]
      }

      return payload
    },
  },
};
</script>